import { useState } from "react";

//Redux
import { connect } from "react-redux";
import uiActions from "../../../../redux/ui/action";
import authActions from "../../../../redux/auth/action";
import userPreferenceActions from "../../../../redux/user_preference/action";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "./UserAttendance.css";
import HeaderLeft from "../../structure_components/desktop_screens/header_component_two/header_left/header_left";
import Header_component from "../../structure_components/desktop_screens/header_component/header_component";
import { ToastContainer } from "react-toastify";
import UserDayAttendance from "./userDayWise/UserDayAttendance";
import UserMonthAttendance from "./userMonthWise/UserMonthAttendance";
import LoaderPopUp from "../../../../components/loader/loader";

function UserAttendance(props) {
  let { userPreference, setUser, setUserPreference, loader } = props;
  const [activeTab, setActiveTab] = useState("day-wise");

  return (
    <>
      <ToastContainer />
      <Header_component />
      <div className="user-attendance-page__brand">
        <HeaderLeft
          userPreference={userPreference}
          setUserPreference={setUserPreference}
          setUser={setUser}
        />
      </div>
      <div className="user-attendance-wrapper user-attendance-page">
        <div className="attendance-wrapper">
          <div className="attendance-container">
            <div className="attendance-tab-header">
              <button
                type="button"
                className={`attendance-tab ${
                  activeTab === "day-wise" ? "active-tab" : ""
                }`}
                onClick={() => setActiveTab("day-wise")}
              >
                Day-wise Attendance
              </button>
              <button
                type="button"
                className={`attendance-tab ${
                  activeTab === "monthly" ? "active-tab" : ""
                }`}
                onClick={() => setActiveTab("monthly")}
              >
                Monthly Attendance
              </button>
            </div>

            <div className="attendance-tab-content">
              {activeTab === "day-wise" ? (
                <UserDayAttendance />
              ) : (
                <UserMonthAttendance />
              )}
            </div>
          </div>
        </div>
      </div>
      {loader && <LoaderPopUp />}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setUser: (payload) => {
      dispatch(authActions.setUser(payload));
    },
    setUserPreference: (payload) => {
      dispatch(userPreferenceActions.setUserPreference(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAttendance);
